import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

const url = environment.wsUrl;

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private http: HttpClient) { }

  crearUsuario(req): Observable<any> {
    return this.http.post(url + 'repse/usuario', req);
  }

  verSubsidiarias(): Observable<any> {
    return this.http.get(url + 'repse/empresa?traerSubsidiarias=true');
  }

  eliminarUsuario(idUsuario): Observable<any> {
    return this.http.delete(url + 'repse/usuario/' + idUsuario);
  }

  verSubsdiariasId(idEmpresa): Observable<any> {
    return this.http.get(url + 'repse/empresa?traerSubsidiarias=true&idEmpresa=' + idEmpresa);
  }

  consultarUsuario(req): Observable<any> {
    //return this.http.post(url + 'xccm/user/consultarUsuarios', req);
    return this.http.get(url + 'repse/usuario/consultaUsuarios');
  }

  consultaUsuario(): Observable<any> {
    //return this.http.post(url + 'xccm/user/consultarUsuarios', req); endpoint original
    return this.http.get(url + 'repse/usuario/consultaUsuarios');
  }

  actualizarUsuario(req): Observable<any> {
    return this.http.post(url + 'repse/usuario/updatev2', req);
  }

  agregaUsuarioAlGrupo(datos): Observable<any> {
    return this.http.post(url + 'xccm/group/add/userV2', datos);
  }

  eliminaUsuarioAlGrupo(datos): Observable<any> {
    return this.http.post(url + 'xccm/group/remove/userV2', datos);
  }


  crearGrupo(req): Observable<any> {
    return this.http.post(url + 'xccm/group/create', req);
  }

  eliminarGrupo(idGrupo): Observable<any> {
    return this.http.delete(url + 'xccm/group/delete/' + idGrupo);
  }
  actualizaNombreGrupo(data) {
    return this.http.post(url + 'xccm/group/actualizarNombre', data);

  }

  consultaGrupos() {
    return this.http.get(url + 'xccm/group/consultaGrupos').pipe(map(resp => resp['resultado']));

  }
  consultarGrupo(idGrupo) {
    http://ies-webcontent.com.mx/xccm/group/consultaGrupoById/70
    return this.http.get(url + 'xccm/group/consultaGrupoById/' + idGrupo).pipe(map(resp => resp['resultado']));
  }

  resetContraseña(req): Observable<any> {
    return this.http.post(url + 'xccm/auth/reseteoContrasenia', req);
  }

  // ALTA TIPO DOCUMENTAL.............................................

  crearTipoDocumento(name, attributes, fatherTypes, fatherTypesAttributes): Observable<any> {
    const doc = { name, attributes, fatherTypes, fatherTypesAttributes };
    console.log(doc);
    return this.http.put(url + 'xccm/type/create', doc);
  }

  crearTipoDocumentoRepse(name, documentTypeLabel, attributes, fatherTypes, fatherTypesAttributes): Observable<any> {
    const doc = { name, documentTypeLabel, attributes, fatherTypes, fatherTypesAttributes, "formatoOcr": name, "validacionesOcr": null };
    console.log(doc);
    return this.http.put(url + 'repse/type/create', doc);
  }

  catTipoCampo(): Observable<any> {
    return this.http.get(url + 'xccm/type/datatype').pipe(map(resp => resp['resultado']));
  }

  consultaTipoDocumento(doc): Observable<any> {
    return this.http.get(url + 'xccm/type/get/' + doc);
  }

  consultaTodosTiposDocumentos(): Observable<any> {
    return this.http.get(url + 'xccm/type/getAll');
  }

  consultaTodosTiposDocumentosRepse(): Observable<any> {
    return this.http.get(url + 'webcontent/sistema/repse/type');
  }

  eliminaTipoDocumento(tipo): Observable<any> {
    return this.http.delete(url + 'xccm/type/deleteNodeType/' + tipo);
  }

  editarTipoDocumental(req): Observable<any> {
    return this.http.post(url + 'xccm/type/update', req);
  }

  editarTipoDocumentalRepse(req): Observable<any> {
    return this.http.post(url + 'repse/type/update', req);
  }

  actualizarNombreTipoDocimental(data) {
    return this.http.post(url + 'xccm/type/actualizar/nombreNodeType', data);
  }
  actualizarNombreTipoDocimentalRepse(data) {
    return this.http.post(url + 'xccm/type/actualizar/nombreNodeType', data);
  }
  // Servicio Acl

  consultarCatAcl(req): Observable<any> {
    return this.http.post(url + 'xccm/adminAcl/consultarCatAcl', req);

  }

  administrarCatAcl(req): Observable<any> {
    return this.http.post(url + 'xccm/adminAcl/administrarCatAcl', req);
  }

  crearAdminCatAcl(datos): Observable<any> {
    return this.http.post(url + 'xccm/adminAcl/catAdminAcl', datos);
  }

  eliminarAdminCatAcl(req): Observable<any> {
    return this.http.post(url + 'xccm/adminAcl/catAdminAcl', req);
  }

  consultarAdminCatAcl(req): Observable<any> {
    return this.http.post(url + 'xccm/adminAcl/consultarAdminAcl', req);
  }
  consultarCataloPermisosAcl(): Observable<any> {
    return this.http.get(url + 'xccm/adminAcl/consultarPermiso');
  }

  //Bitacora
  getBitacora(filtros?: string, modulo?: string, page?: string, size?: string): Observable<any> {
    return this.http.get(url + `repse/bitacora?${filtros}&page=${page}&size=${size}&modulo=${modulo}`);
  }

  setAccionBitacora(req): Observable<any> {
    return this.http.post(url + `repse/bitacora`, req);
  }

  getReporteMeses(idSubsidiaria): Observable<any> {
    return this.http.get(url + `repse/empresa/ejercicio?idSubsidiaria=${idSubsidiaria}`);
  }

  getCategoriasDocs(): Observable<any> {
    return this.http.get(url + `repse/empresa/cumplimiento/categoria`);
  }


  getReporteMensual(ejercicio, mes, idSubsidiaria): Observable<any> {
    return this.http.get(url + `repse/empresa/cumplimiento/mensual?subsidiaria=${idSubsidiaria}&ejercicio=${ejercicio}&numeroMes=${mes}`);
  }

  getReporteAnual(ejercicio, idSubsidiaria): Observable<any> {
    return this.http.get(url + `repse/empresa/cumplimiento/anual?subsidiaria=${idSubsidiaria}&ejercicio=${ejercicio}`);
  }

  enviarCumplimiento(payload) {

   return  this.http.post(url+'repse/empresa/cumplimiento', payload);
  }

  obtnerCumplimientoDocumental(nodeType){
    return this.http.get(url+`repse/empresa/cumplimiento/${nodeType}`)
  }


  oauthLogin() {
    return this.http.get(url + 'oauth/login');
  }
}
